export default "data:image/webp;base64,UklGRj4AAABXRUJQVlA4TDEAAAAvJ4AIAAWZgIU6AgugmTRL4CDMNprCvvM64wMjzDYawhgnda9z7f8ECHjcCnf35X8KAA=="